import * as Styled from '../styles'
import { IconProps } from '../types'

export const IconDirectDebit = ({ width = '780px', height = '500px', ...rest }: IconProps) => (
  <Styled.IconWrapper width={width} height={height} {...rest}>
    <svg
      width={width}
      height={height}
      enableBackground="new 0 0 780 500"
      version="1.1"
      viewBox="0 0 780 500"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="50" y="50" width="680" height="400" rx="20" ry="20" fill="#FFFFFF" stroke="#2E5BBA" strokeWidth="10" />
      <text
        x="390"
        y="230"
        fontFamily="Arial, sans-serif"
        fontSize="120"
        fontWeight="bold"
        fill="#2E5BBA"
        textAnchor="middle"
      >
        DIRECT
      </text>
      <text
        x="390"
        y="360"
        fontFamily="Arial, sans-serif"
        fontSize="120"
        fontWeight="bold"
        fill="#2E5BBA"
        textAnchor="middle"
      >
        DEBIT
      </text>
    </svg>
  </Styled.IconWrapper>
)
